<script setup lang="ts">
import { computed, type CSSProperties } from "vue";
import SubListItem from "./components/SubListItem.vue";
import { useListItem } from "@/hooks";

const props = withDefaults(
  defineProps<{
    property: string;
    columnNum?: number;
    gutter?: number;
    emptyText?: string;
  }>(),
  { data: () => [], gutter: 10 }
);

const itemStyle = computed(() => {
  const style: CSSProperties = {};
  if (props.columnNum && props.columnNum > 0) {
    style.flexBasis = `${100 / props.columnNum}%`;
  }

  style.padding = `0 ${props.gutter}px ${props.gutter}px 0`;
  return style;
});

const { item } = useListItem();
const data = computed(() => (item.value ? item.value[props.property] : []));
</script>
<template>
  <div class="mp-list-sub-list">
    <div
      class="mp-list-sub-list__content"
      :style="{ padding: `${props.gutter}px 0 0 ${props.gutter}px` }"
      v-if="data.length > 0"
    >
      <div v-for="(item, index) in data" :key="index" :style="itemStyle">
        <SubListItem :item="item" :index="index">
          <slot />
        </SubListItem>
      </div>
    </div>
    <slot name="empty" v-else>
      <div class="mp-list-sub-list__empty">
        <span>{{ emptyText }}</span>
      </div>
    </slot>
  </div>
</template>
<style lang="scss">
.mp-list-sub-list {
  &,
  &__content {
    width: 100%;
  }

  &__content {
    display: inline-flex;
    flex-wrap: wrap;
  }

  &__empty {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #c0c4cc;
    font-size: 16px;
  }
}
</style>
